(function (Drupal, once) {
  'use strict';

  // Create or extend shared namespace
  window.McmnExperience = window.McmnExperience || {};
  const Mcmn = window.McmnExperience;

  /**
   * Initialize Chapter 3 (Feast) interactions
   */
  function initChapter3(svgContainer, svg, chapterState, sectionType) {
    // Ensure SVG container allows pointer events
    if (svgContainer) {
      svgContainer.style.pointerEvents = 'auto';
    }
    if (svg) {
      svg.style.pointerEvents = 'auto';
    }
    
    // Hide hotspot immediately
    const hotspot = svg.querySelector('#hotspot');
    if (hotspot) {
      hotspot.style.visibility = 'hidden';
      hotspot.style.display = 'none';
      hotspot.style.opacity = '0';
      hotspot.style.pointerEvents = 'none';
    }
    
    // Map food item IDs (in feast) to their plate versions
    const foodItems = {
      'arroz': 'plate-arroz',
      'coditos': 'plate-coditos',
      'morcilla': 'plate-morcilla',
      'papa': 'plate-papa',
      'pasteles': 'plate-pasteles',
      'pernil': 'plate-pernil',
      'salad': 'plate-salad'
    };

    // Initialize audio immediately (buttons need to show right away)
    initChapter3Audio(svgContainer, svg, chapterState, sectionType);
    
    // Wait a bit for SVG to be fully parsed, then initialize drag and drop
    setTimeout(() => {
      initFoodDragDrop(svgContainer, svg, foodItems, chapterState, sectionType);
    }, 100);
  }

  /**
   * Initialize audio for Chapter 3
   */
  function initChapter3Audio(svgContainer, svg, chapterState, sectionType) {
    const hotspot = svg.querySelector('#hotspot');
    
    // Initialize audio
    let audio = null;
    let isPlaying = false;
    let isMuted = false;
    let hotspotActivated = false; // Track if hotspot has been clicked
    let isStartingAudio = false; // Prevent multiple simultaneous audio starts
    
    // Get base path for files
    let basePath = '';
    if (typeof Drupal !== 'undefined' && Drupal.settings && Drupal.settings.basePath) {
      basePath = Drupal.settings.basePath;
    } else {
      const pathParts = window.location.pathname.split('/');
      const filtered = pathParts.filter(p => p);
      if (filtered.length > 0) {
        filtered.pop();
      }
      basePath = filtered.length > 0 ? '/' + filtered.join('/') : '';
    }
    basePath = basePath.replace(/\/$/, '');
    
    const audioPath = basePath + '/themes/custom/discoverpr_v2_theme/audio/mcmn-experience/chapter3.mp4';
    
    // Get audio control buttons - look in closest .mcmn-section, not from svgContainer
    // First, try to find the mcmn-svg-container (svgContainer might be the SVG element itself)
    let container = svgContainer;
    if (svg && svg.parentElement && svg.parentElement.classList && 
        svg.parentElement.classList.contains('mcmn-svg-container')) {
      container = svg.parentElement;
    }
    
    // Now find the section
    let section = null;
    if (container && container.closest) {
      section = container.closest('.mcmn-section');
    }
    // Fallback: if not found via closest, search up the DOM
    if (!section) {
      let parent = container;
      while (parent && !section) {
        parent = parent.parentElement;
        if (parent && parent.classList && parent.classList.contains('mcmn-section')) {
          section = parent;
        }
      }
    }
    
    // If still no section, try searching for chapter 3 section directly
    if (!section) {
      section = document.querySelector('.mcmn-chapter-3');
    }
    
    const playButton = section ? section.querySelector('[data-mcmn-audio="play"]') : null;
    const pauseButton = section ? section.querySelector('[data-mcmn-audio="pause"]') : null;
    const muteButton = section ? section.querySelector('[data-mcmn-audio="mute"]') : null;
    
    // Show play button, hide pause button
    function showPlayButton() {
      if (playButton) {
        playButton.style.setProperty('display', 'flex', 'important');
        playButton.style.visibility = 'visible';
      }
      if (pauseButton) {
        pauseButton.style.setProperty('display', 'none', 'important');
        pauseButton.style.visibility = 'hidden';
      }
    }
    
    // Show pause button, hide play button
    function showPauseButton() {
      if (pauseButton) {
        pauseButton.style.setProperty('display', 'flex', 'important');
        pauseButton.style.visibility = 'visible';
      }
      if (playButton) {
        playButton.style.setProperty('display', 'none', 'important');
        playButton.style.visibility = 'hidden';
      }
    }
    
    // Show audio controls after first interaction (only mute button, play/pause controlled separately)
    function showAudioControls() {
      if (muteButton) {
        muteButton.style.setProperty('display', 'flex', 'important');
        muteButton.style.visibility = 'visible';
      }
    }
    
    // Initialize: Hide all buttons initially until audio starts
    if (playButton) {
      playButton.style.setProperty('display', 'none', 'important');
    }
    if (pauseButton) {
      pauseButton.style.setProperty('display', 'none', 'important');
    }
    if (muteButton) {
      muteButton.style.setProperty('display', 'none', 'important');
    }
    
    // Start audio
    function startAudio() {
      // Prevent multiple simultaneous calls
      if (isStartingAudio) {
        return;
      }
      
      // Prevent multiple audio instances
      if (!audio) {
        audio = new Audio(audioPath);
        audio.loop = true;
        
        // Register this audio instance
        if (Mcmn.registerAudio) {
          Mcmn.registerAudio(sectionType, audio);
        }
        
        // Ensure looping works even if browser doesn't support loop attribute
        audio.addEventListener('ended', function() {
          if (isPlaying) {
            audio.currentTime = 0;
            audio.play().catch(error => {
              // Audio restart failed
            });
          }
        });
        
        audio.addEventListener('play', function() {
          isPlaying = true;
          isStartingAudio = false; // Reset flag when play event fires
          showPauseButton();
          showAudioControls();
          // Disable hotspot while playing
          if (hotspot) {
            hotspot.style.pointerEvents = 'none';
            hotspot.style.cursor = 'default';
          }
        });
        
        audio.addEventListener('pause', function() {
          isPlaying = false;
          showPlayButton();
          // Re-enable hotspot so it can act as a play button
          if (hotspot) {
            hotspot.style.pointerEvents = 'auto';
            hotspot.style.cursor = 'pointer';
          }
        });
      }
      
      // Only play if not already playing
      if (!isPlaying && audio && !isStartingAudio) {
        isStartingAudio = true; // Set flag to prevent multiple calls
        audio.play().then(() => {
          // Ensure buttons are shown even if play event hasn't fired yet
          isStartingAudio = false; // Reset flag after play promise resolves
          showPauseButton();
          showAudioControls();
        }).catch(error => {
          isStartingAudio = false; // Reset flag on error
        });
      }
    }
    
    // Pause audio
    function pauseAudio() {
      if (audio && isPlaying) {
        audio.pause();
      }
    }
    
    // Toggle mute
    function toggleMute() {
      if (!audio) return;
      
      isMuted = !isMuted;
      audio.muted = isMuted;
      
      // Update mute button visual state
      if (muteButton) {
        if (isMuted) {
          muteButton.classList.add('muted');
        } else {
          muteButton.classList.remove('muted');
        }
      }
    }
    
    // Wire up play button (mobile touch support)
    if (playButton) {
      const playHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        startAudio();
      };
      playButton.addEventListener('click', playHandler);
      playButton.addEventListener('touchend', playHandler, { passive: false });
    }
    
    // Wire up pause button (mobile touch support)
    if (pauseButton) {
      const pauseHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        pauseAudio();
      };
      pauseButton.addEventListener('click', pauseHandler);
      pauseButton.addEventListener('touchend', pauseHandler, { passive: false });
    }
    
    // Wire up mute button (mobile touch support)
    if (muteButton) {
      const muteHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMute();
      };
      muteButton.addEventListener('click', muteHandler);
      muteButton.addEventListener('touchend', muteHandler, { passive: false });
    }
    
    // Store audio start function reference for message handler
    // The feast message will trigger audio start
    window.McmnExperience = window.McmnExperience || {};
    if (!window.McmnExperience.chapter3AudioStart) {
      window.McmnExperience.chapter3AudioStart = {};
    }
    window.McmnExperience.chapter3AudioStart[sectionType] = function() {
      // If audio exists and is paused, resume it
      if (audio && !isPlaying) {
        startAudio();
        return;
      }
      
      // Prevent multiple clicks from starting audio multiple times (only on first start)
      if (hotspotActivated && isPlaying) {
        return;
      }
      
      // Mark hotspot as complete on first activation
      if (!hotspotActivated) {
        hotspotActivated = true;
        if (Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
          Mcmn.CookieManager.markHotspotComplete(sectionType, 'hotspot');
          // Check completion after marking hotspot
          if (Mcmn.checkCompletion) {
            const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
            Mcmn.checkCompletion(viewedSections);
          }
        }
      }
      
      // Start audio when message is clicked
      startAudio();
    };
    
    // Note: Audio does NOT auto-start - waits for user to click message
  }

  /**
   * Initialize food item drag and drop for Chapter 3 - EXACTLY like Chapter 1
   */
  function initFoodDragDrop(svgContainer, svg, foodItems, chapterState, sectionType) {
    // Initialize SVG.js
    const svgJs = Mcmn.initSvgJs ? Mcmn.initSvgJs(svg) : null;
    if (!svgJs) {
      return;
    }
    
    // Get plate container element (already in SVG, CSS positions it below viewport)
    const plateElement = svg.querySelector('#plate-container');
    if (!plateElement) {
      // Try waiting longer for SVG to load
      setTimeout(() => {
        const retryPlate = svg.querySelector('#plate-container');
        if (retryPlate) {
          // Reinitialize with the plate found
          initFoodDragDrop(svgContainer, svg, foodItems, chapterState, sectionType);
        }
      }, 500);
      return;
    }
    
    // Track placed food items using Set (like Chapter 1)
    let placedFoodItems = chapterState.placedFoodItems || new Set();
    if (!(placedFoodItems instanceof Set)) {
      placedFoodItems = new Set(placedFoodItems);
    }
    chapterState.placedFoodItems = placedFoodItems;
    
    let dragElement = null;
    let dragElementBbox = null;
    let currentFoodId = null;
    let plateShown = false;
    let isPlacing = false;
    let placingFoodItems = new Set();
    let currentClickHandler = null;
    let rafId = null; // RequestAnimationFrame ID for throttling drag updates
    
    // Restore state on load
    restoreFoodItems();
    
      // Show plate with animation (slide up from bottom on first food click)
      // CSS positions it below viewport initially with translateY(150px)
      function showPlate() {
        if (plateShown || !plateElement) return;
        
        plateShown = true;
        
          // Animate plate sliding up to final position (translateY(0))
        // if height is greater then 950 move to 10
        if (window.innerHeight > 950) {
          gsap.to(plateElement, {
            y: 10,
            duration: 0.8,
            ease: 'power2.out'
          });
        }else{
          // CSS has it at translateY(150px) initially
          gsap.to(plateElement, {
            y: -30, // Move to original SVG position
            duration: 0.8,
            ease: 'power2.out'
          });
  

        }
      }
    
    // Cache for SVG coordinate calculations (performance optimization for mobile)
    let cachedSvgRect = null;
    let cachedCTM = null;
    let cachedViewBox = null;
    let cacheTimestamp = 0;
    const CACHE_DURATION = 100; // Cache for 100ms
    
    // Function to convert screen coordinates to SVG coordinates (optimized with caching)
    function screenToSVG(x, y) {
      const now = performance.now();
      
      // Recalculate cache if stale or missing
      if (!cachedSvgRect || !cachedCTM || (now - cacheTimestamp) > CACHE_DURATION) {
        cachedSvgRect = svg.getBoundingClientRect();
        cachedCTM = svg.getScreenCTM();
        cachedViewBox = svg.viewBox.baseVal;
        cacheTimestamp = now;
      }
      
      const svgPoint = svg.createSVGPoint();
      svgPoint.x = x;
      svgPoint.y = y;
      
      if (cachedCTM) {
        const inverseCTM = cachedCTM.inverse();
        const transformedPoint = svgPoint.matrixTransform(inverseCTM);
        return { x: transformedPoint.x, y: transformedPoint.y };
      }
      
      // Fallback: simple calculation
      const scaleX = cachedViewBox.width / cachedSvgRect.width;
      const scaleY = cachedViewBox.height / cachedSvgRect.height;
      
      return {
        x: (x - cachedSvgRect.left) * scaleX,
        y: (y - cachedSvgRect.top) * scaleY
      };
    }
    
    // Check if point is over plate (using bounding box)
    function isOverPlate(clientX, clientY) {
      if (!plateElement) return false;
      
      // Allow dropping even if plate hasn't fully animated yet
      // Just check if we have a valid plate element
      
      const svgPoint = screenToSVG(clientX, clientY);
      const plateBbox = plateElement.getBBox();
      
      const isInside = svgPoint.x >= plateBbox.x &&
             svgPoint.x <= plateBbox.x + plateBbox.width &&
             svgPoint.y >= plateBbox.y &&
             svgPoint.y <= plateBbox.y + plateBbox.height;
      
      return isInside;
    }
    
    // Create drag element from plate food item (EXACTLY like Chapter 1's createDragOrnament)
    function createDragFoodItem(foodId) {
      const plateFoodId = foodItems[foodId];
      const originalFood = svg.querySelector('#' + plateFoodId);
      
      if (!originalFood) {
        return null;
      }
      
      // Get the original food's bbox BEFORE cloning (EXACTLY like Chapter 1)
      const originalJs = SVG.adopt(originalFood);
      if (!originalJs) return null;
      
      // Temporarily reset any transforms to get true original bbox
      const originalTransform = originalFood.getAttribute('transform') || '';
      originalJs.transform({ x: 0, y: 0, scale: 1 });
      const originalBbox = originalJs.bbox();
      
      // Restore original transform if it existed
      if (originalTransform) {
        originalFood.setAttribute('transform', originalTransform);
      }
      
      // Clone the food element (EXACTLY like Chapter 1)
      const clone = originalFood.cloneNode(true);
      clone.id = foodId + '-drag-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
      clone.style.pointerEvents = 'none';
      clone.style.visibility = 'visible';
      clone.style.opacity = '1';
      
      // Remove any existing transform from clone to start fresh
      clone.removeAttribute('transform');
      
      // Add drop shadow filter for better visibility (like Chapter 1)
      let defs = svg.querySelector('defs');
      if (!defs) {
        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        svg.insertBefore(defs, svg.firstChild);
      }
      
      // Check if filter already exists
      let dropShadowFilter = defs.querySelector('#drag-drop-shadow');
      if (!dropShadowFilter) {
        dropShadowFilter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        dropShadowFilter.id = 'drag-drop-shadow';
        dropShadowFilter.setAttribute('x', '-50%');
        dropShadowFilter.setAttribute('y', '-50%');
        dropShadowFilter.setAttribute('width', '200%');
        dropShadowFilter.setAttribute('height', '200%');
        
        const feGaussianBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('stdDeviation', '4');
        
        const feOffset = document.createElementNS('http://www.w3.org/2000/svg', 'feOffset');
        feOffset.setAttribute('dx', '0');
        feOffset.setAttribute('dy', '2');
        feOffset.setAttribute('result', 'offsetblur');
        
        const feFlood = document.createElementNS('http://www.w3.org/2000/svg', 'feFlood');
        feFlood.setAttribute('flood-color', 'rgba(0, 0, 0, 0.5)');
        
        const feComposite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
        feComposite.setAttribute('in2', 'offsetblur');
        feComposite.setAttribute('operator', 'in');
        
        const feMerge = document.createElementNS('http://www.w3.org/2000/svg', 'feMerge');
        const feMergeNode1 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        const feMergeNode2 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        feMergeNode2.setAttribute('in', 'SourceGraphic');
        
        feMerge.appendChild(feMergeNode1);
        feMerge.appendChild(feMergeNode2);
        
        dropShadowFilter.appendChild(feGaussianBlur);
        dropShadowFilter.appendChild(feOffset);
        dropShadowFilter.appendChild(feFlood);
        dropShadowFilter.appendChild(feComposite);
        dropShadowFilter.appendChild(feMerge);
        defs.appendChild(dropShadowFilter);
      }
      
      // Apply filter to clone
      clone.setAttribute('filter', 'url(#drag-drop-shadow)');
      
      // Add to SVG at the end to ensure it's on top
      svg.appendChild(clone);
      
      // Wrap with SVG.js
      const cloneJs = SVG.adopt(clone);
      if (!cloneJs) return null;
      
      // Ensure it's on top
      if (cloneJs.node && cloneJs.node.parentNode) {
        cloneJs.node.parentNode.appendChild(cloneJs.node);
      }
      
      // Reset all transforms to ensure clean state (EXACTLY like Chapter 1)
      cloneJs.transform({ x: 0, y: 0, scale: 1 });
      cloneJs.opacity(1);
      cloneJs.show();
      cloneJs.scale(1);
      
      // Return both the cloneJs and the original bbox (EXACTLY like Chapter 1)
      return { element: cloneJs, bbox: originalBbox };
    }
    
    // Mouse move handler (optimized with requestAnimationFrame)
    function handleMouseMove(e) {
      if (!dragElement || !currentFoodId || !dragElementBbox) {
        return;
      }
      
      // Prevent scrolling on touch devices
      if (e.type === 'touchmove') {
        e.preventDefault();
      }
      
      // Cancel previous animation frame if pending
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      
      // Get coordinates immediately
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      
      // Schedule update for next frame (throttles to display refresh rate)
      rafId = requestAnimationFrame(function() {
        const svgPoint = screenToSVG(coords.clientX, coords.clientY);
        
        // Calculate position to center at cursor
        const centerX = svgPoint.x - (dragElementBbox.width / 2);
        const centerY = svgPoint.y - (dragElementBbox.height / 2);
        
        // Only update position - properties are set once on drag start
        dragElement.move(centerX, centerY);
        
        rafId = null;
      });
    }
    
    // Click/touch handler to place food item (EXACTLY like Chapter 1's handleClick)
    function handleClick(e) {
      
      // Don't process if clicking on a food item (but only for mouse events)
      // For touch events, the target is often the original element even if finger moved
      if (e.type !== 'touchend') {
        const clickedFood = e.target.closest('[data-food-item]');
        if (clickedFood) {
          return;
        }
      }
      
      // Stop propagation
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      
      if (!dragElement || !currentFoodId) {
        return;
      }
      
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      
      // CRITICAL: Prevent double placement (EXACTLY like Chapter 1)
      if (isPlacing) {
        return;
      }
      
      // Set flag immediately
      isPlacing = true;
      
      // Store current food values before clearing
      const foodToPlace = currentFoodId;
      
      // Remove event listeners immediately (EXACTLY like Chapter 1) - mouse and touch
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      if (currentClickHandler) {
        svgContainer.removeEventListener('click', currentClickHandler, true);
        svgContainer.removeEventListener('click', currentClickHandler, false);
        svgContainer.removeEventListener('touchend', currentClickHandler, true);
        svgContainer.removeEventListener('touchend', currentClickHandler, false);
        currentClickHandler = null;
      }
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // STRICT: Only allow dropping on the plate
      const isOver = isOverPlate(coords.clientX, coords.clientY);
      
      if (!isOver) {
        // Clicked outside plate - cancel drag
        isPlacing = false;
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        return;
      }
      
      // Place food on plate
      placeFoodOnPlate(foodToPlace);
    }
    
    // Place food item on plate (show the plate version in its default position)
    function placeFoodOnPlate(foodId) {
      if (!foodId || !plateElement) {
        isPlacing = false;
        cancelDrag();
        return;
      }
      
      // CRITICAL: Check if this placement is already in progress
      const placementKey = foodId + '-' + Date.now();
      if (placingFoodItems.has(placementKey)) {
        return;
      }
      
      // Mark this placement as in progress
      placingFoodItems.add(placementKey);
      
      // Find the plate version of this food item
      const plateFoodId = foodItems[foodId];
      const plateFoodItem = svg.querySelector('#' + plateFoodId);
      
      if (!plateFoodItem) {
        isPlacing = false;
        currentFoodId = null;
        placingFoodItems.delete(placementKey);
        cancelDrag();
        return;
      }
      
      // Show the plate food item (it's already positioned correctly in the SVG)
      // Make it visible first, then animate opacity
      plateFoodItem.style.visibility = 'visible';
      
      // Animate it in with a fade (from 0 to 1)
      gsap.fromTo(plateFoodItem, 
        { opacity: 0 },
        { 
          opacity: 1,
          duration: 0.4,
          ease: 'power2.out'
        }
      );
      
      // Track this food item as placed
      placedFoodItems.add(foodId);
      chapterState.placedFoodItems = placedFoodItems;
      if (Mcmn.saveChapterState) {
        Mcmn.saveChapterState(sectionType, chapterState);
      }
      
      // Mark food grab as complete when first food item is placed
      if (placedFoodItems.size === 1 && Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
        Mcmn.CookieManager.markHotspotComplete(sectionType, 'food-grab');
        // Check completion after marking hotspot
        if (Mcmn.checkCompletion) {
          const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
          Mcmn.checkCompletion(viewedSections);
        }
      }
      
      // Check if we should show the get-recipes button (2+ items)
      checkAndShowRecipesButton();
      
      // Hide the hotspot after first item is placed
      // COMMENTED OUT: Keep hotspots visible even after interaction
      // hideHotspot();
      
      // Disable the feast food item (can't drag it again)
      disableFoodItem(foodId);
      
      // Make placed food item clickable to remove
      setupFoodRemoval(plateFoodItem, foodId, placementKey);
      
      // IMMEDIATELY remove drag element
      if (dragElement) {
        if (dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
        }
        dragElement = null;
      }
      
      // Cleanup
      dragElementBbox = null;
      isPlacing = false;
      placingFoodItems.delete(placementKey);
      currentFoodId = null;
      currentClickHandler = null;
      svgContainer.style.cursor = 'default';
    }
    
    // Disable feast food item (already on plate)
    function disableFoodItem(foodId) {
      const foodElement = svg.querySelector('#' + foodId);
      if (foodElement) {
        foodElement.classList.add('disabled');
        foodElement.style.pointerEvents = 'none';
        foodElement.style.cursor = 'not-allowed';
      }
    }
    
    // Enable feast food item (removed from plate)
    function enableFoodItem(foodId) {
      const foodElement = svg.querySelector('#' + foodId);
      if (foodElement) {
        foodElement.classList.remove('disabled');
        foodElement.style.pointerEvents = 'auto';
        foodElement.style.cursor = 'pointer';
      }
    }
    
    // Setup click handler to remove food from plate
    function setupFoodRemoval(plateFoodItem, foodId, placementKey) {
      plateFoodItem.style.cursor = 'pointer';
      plateFoodItem.style.pointerEvents = 'auto';
      
      // Add hover effect
      plateFoodItem.addEventListener('mouseenter', function() {
        gsap.to(plateFoodItem, {
          scale: 1.1,
          duration: 0.2,
          ease: 'power2.out',
          transformOrigin: 'center center'
        });
      });
      
      plateFoodItem.addEventListener('mouseleave', function() {
        gsap.to(plateFoodItem, {
          scale: 1,
          duration: 0.2,
          ease: 'power2.out'
        });
      });
      
      // Click to remove from plate
      plateFoodItem.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Animate removal (shrink and fade out)
        gsap.to(plateFoodItem, {
          opacity: 0,
          scale: 0.5,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: function() {
            // Hide and reset
            plateFoodItem.style.visibility = 'hidden';
            plateFoodItem.style.opacity = '0';
            gsap.set(plateFoodItem, { scale: 1 }); // Reset scale for next time
            
            // Update state
            placedFoodItems.delete(foodId);
            chapterState.placedFoodItems = placedFoodItems;
            if (Mcmn.saveChapterState) {
              Mcmn.saveChapterState(sectionType, chapterState);
            }
            
            // Check if we should hide the get-recipes button (less than 2 items)
            checkAndShowRecipesButton();
            
            // Show hotspot again if all items are removed
            if (placedFoodItems.size === 0) {
              showHotspot();
            }
            
            // Re-enable the feast food item (can drag it again)
            enableFoodItem(foodId);
          }
        });
      });
    }
    
    // Check if we should show or hide the get-recipes button
    function checkAndShowRecipesButton() {
      const recipesButton = svg.querySelector('#get-recipes');
      if (!recipesButton) return;
      
      // Show button if 2 or more items are on the plate
      if (placedFoodItems.size >= 2) {
        gsap.to(recipesButton, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.4,
          ease: 'power2.out'
        });
      } else {
        // Hide button if less than 2 items
        gsap.to(recipesButton, {
          opacity: 0,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: function() {
            recipesButton.style.visibility = 'hidden';
          }
        });
      }
    }
    
    // Initialize get-recipes button click handler
    function initGetRecipesButton() {
      const recipesButton = svg.querySelector('#get-recipes');
      if (!recipesButton) return;
      
      // Make it clickable
      recipesButton.style.cursor = 'pointer';
      recipesButton.style.pointerEvents = 'auto';
      
      // // Add hover effect
      // recipesButton.addEventListener('mouseenter', function() {
      //   gsap.to(recipesButton, {
      //     scale: 1.05,
      //     duration: 0.2,
      //     ease: 'power2.out',
      //     transformOrigin: 'center center'
      //   });
      // });
      
      // recipesButton.addEventListener('mouseleave', function() {
      //   gsap.to(recipesButton, {
      //     scale: 1,
      //     duration: 0.2,
      //     ease: 'power2.out'
      //   });
      // });
      
      // Click handler (mobile touch support)
      const recipesButtonHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Check if newsletter has been submitted
        const hasNewsletter = Mcmn.CookieManager && Mcmn.CookieManager.hasSubmittedNewsletter();
        
        if (!hasNewsletter) {
          // Show newsletter popup
          
          // Try multiple methods to show popup
          setTimeout(function() {
            // Method 1: Use Drupal API if available
            if (typeof Drupal !== 'undefined' && Drupal.mcmnExperiencePopup && Drupal.mcmnExperiencePopup.show) {
              Drupal.mcmnExperiencePopup.show();
              return;
            }
            
            // Method 2: Dispatch custom event
            document.dispatchEvent(new CustomEvent('showMcmnPopup'));
            
            // Method 3: Direct DOM manipulation as fallback
            const newsletterPopup = document.querySelector('[data-mcmn-popup]');
            if (newsletterPopup) {
              newsletterPopup.classList.add('is-visible');
              document.body.style.overflow = 'hidden';
            }
          }, 100);
        } else {
          // Newsletter submitted, download PDF file
          
          // Get base path for files (same logic as audio path)
          let basePath = '';
          if (typeof Drupal !== 'undefined' && Drupal.settings && Drupal.settings.basePath) {
            basePath = Drupal.settings.basePath;
          } else {
            const pathParts = window.location.pathname.split('/');
            const filtered = pathParts.filter(p => p);
            if (filtered.length > 0) {
              filtered.pop();
            }
            basePath = filtered.length > 0 ? '/' + filtered.join('/') : '';
          }
          basePath = basePath.replace(/\/$/, '');
          
          const pdfPath = basePath + '/themes/custom/discoverpr_v2_theme/images/mcmn-experience/MiCasaMiNavidadRecipes.pdf';
          
          // Create temporary anchor element to trigger download
          const link = document.createElement('a');
          link.href = pdfPath;
          link.download = 'MiCasaMiNavidadRecipes.pdf';
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      };
      recipesButton.addEventListener('click', recipesButtonHandler);
      recipesButton.addEventListener('touchend', recipesButtonHandler, { passive: false });
    }
    
    // Hide the hotspot and feast message after first food item is placed
    function hideHotspot() {
      const hotspot = svg.querySelector('#hotspot');
      const feastMessage = svg.querySelector('#feast-message');
      
      // Fade out and hide the hotspot
      if (hotspot) {
        gsap.to(hotspot, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out',
          onComplete: function() {
            hotspot.style.visibility = 'hidden';
            hotspot.style.display = 'none';
          }
        });
      }
      
      // Fade out and hide the feast message
      if (feastMessage) {
        gsap.to(feastMessage, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out',
          onComplete: function() {
            feastMessage.style.visibility = 'hidden';
            feastMessage.style.display = 'none';
          }
        });
      }
    }
    
    // Show the hotspot and feast message when all items are removed
    function showHotspot() {
      const hotspot = svg.querySelector('#hotspot');
      const feastMessage = svg.querySelector('#feast-message');
      
      // Show and fade in the hotspot
      if (hotspot) {
        hotspot.style.display = 'block';
        hotspot.style.visibility = 'visible';
        gsap.to(hotspot, {
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out'
        });
      }
      
      // Show and fade in the feast message
      if (feastMessage) {
        feastMessage.style.display = 'block';
        feastMessage.style.visibility = 'visible';
        gsap.to(feastMessage, {
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out'
        });
      }
    }
    
    // Cancel drag (optimized with animation frame cleanup)
    function cancelDrag() {
      // Cancel any pending animation frame
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      
      // Remove event listeners (mouse and touch)
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      if (currentClickHandler) {
        svgContainer.removeEventListener('click', currentClickHandler, true);
        svgContainer.removeEventListener('click', currentClickHandler, false);
        svgContainer.removeEventListener('touchend', currentClickHandler, true);
        svgContainer.removeEventListener('touchend', currentClickHandler, false);
        currentClickHandler = null;
      }
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // IMMEDIATELY remove drag element
      if (dragElement) {
        if (dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
        }
        dragElement = null;
      }
      
      // Also clean up any leftover drag elements
      const leftoverDragElements = svg.querySelectorAll('[id*="-drag"]');
      leftoverDragElements.forEach(dragEl => {
        if (dragEl && dragEl.parentNode && dragEl.id && dragEl.id.includes('-drag')) {
          try {
            dragEl.parentNode.removeChild(dragEl);
          } catch (e) {
            // Cleanup failed
          }
        }
      });
      
      // Reset all state
      dragElementBbox = null;
      currentFoodId = null;
      isPlacing = false;
      currentClickHandler = null;
      placingFoodItems.clear();
      svgContainer.style.cursor = 'default';
      
      // Clear coordinate cache
      cachedSvgRect = null;
      cachedCTM = null;
      cachedViewBox = null;
    }
    
    // Restore placed food items from saved state
    function restoreFoodItems() {
      // Ensure all plate food items are hidden by default (CSS may not have loaded yet)
      Object.keys(foodItems).forEach(foodId => {
        const plateFoodId = foodItems[foodId];
        const plateFoodItem = svg.querySelector('#' + plateFoodId);
        if (plateFoodItem) {
          plateFoodItem.style.visibility = 'hidden';
          plateFoodItem.style.opacity = '0';
        }
      });
      
      // Show plate if there are items to restore
      if (placedFoodItems.size > 0) {
        // Show plate immediately (no animation on restore)
        // Move from CSS initial position (translateY(150px)) to final position
        plateShown = true;
        gsap.set(plateElement, {
          y: 0 // Final position
        });
        
        // Show only the placed food items
        placedFoodItems.forEach(foodId => {
          const plateFoodId = foodItems[foodId];
          const plateFoodItem = svg.querySelector('#' + plateFoodId);
          
          if (plateFoodItem) {
            plateFoodItem.style.visibility = 'visible';
            plateFoodItem.style.opacity = '1';
            
            // Disable the feast food item (already on plate)
            disableFoodItem(foodId);
            
            // Make it clickable to remove
            setupFoodRemoval(plateFoodItem, foodId, foodId + '-restored');
          }
        });
      }
      // If no items, plate stays at CSS initial position (below viewport)
      
      // Check if we should show the get-recipes button based on restored state
      checkAndShowRecipesButton();
      
      // Hide hotspot and feast message if there are items already placed
      // COMMENTED OUT: Keep hotspots visible even after interaction
      // if (placedFoodItems.size > 0) {
      //   const hotspot = svg.querySelector('#hotspot');
      //   const feastMessage = svg.querySelector('#feast-message');
      //   
      //   if (hotspot) {
      //     hotspot.style.visibility = 'hidden';
      //     hotspot.style.display = 'none';
      //     hotspot.style.opacity = '0';
      //   }
      //   
      //   if (feastMessage) {
      //     feastMessage.style.visibility = 'hidden';
      //     feastMessage.style.display = 'none';
      //     feastMessage.style.opacity = '0';
      //   }
      // }
    }
    
    // Initialize get-recipes button click handler on initial load
    initGetRecipesButton();
    
    // Set up click handlers for each food item in feast
    Object.keys(foodItems).forEach(foodId => {
      const foodElement = svg.querySelector('#' + foodId);
      
      if (!foodElement) {
        return;
      }
      
      // Ensure the element has pointer events enabled
      foodElement.style.cursor = 'pointer';
      foodElement.style.pointerEvents = 'auto';
      foodElement.setAttribute('data-food-item', foodId);
      
      // Make children clickable too
      const children = foodElement.querySelectorAll('*');
      children.forEach(child => {
        if (child.style) {
          child.style.pointerEvents = 'auto';
        }
      });
      
      // Hover effect (like Chapter 1 basket)
      foodElement.addEventListener('mouseenter', function() {
        if (!dragElement) {
          gsap.to(foodElement, {
            scale: 1.1,
            duration: 0.3,
            ease: 'power2.out',
            transformOrigin: 'center center'
          });
          gsap.to(foodElement, {
            filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.5))',
            duration: 0.3
          });
        }
      });
      
      foodElement.addEventListener('mouseleave', function() {
        if (!dragElement) {
          gsap.to(foodElement, {
            scale: 1,
            duration: 0.3,
            ease: 'power2.out'
          });
          gsap.to(foodElement, {
            filter: 'drop-shadow(0 0 0px rgba(255, 255, 255, 0))',
            duration: 0.3
          });
        }
      });
      
      // Click/touch handler (EXACTLY like Chapter 1 basket click)
      const foodClickHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Start audio on first food pickup (only once)
        if (placedFoodItems.size === 0) {
          if (window.McmnExperience && window.McmnExperience.chapter3AudioStart && window.McmnExperience.chapter3AudioStart[sectionType]) {
            window.McmnExperience.chapter3AudioStart[sectionType]();
          }
        }
        
        // Get coordinates (works for mouse and touch)
        const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
        
        // If already dragging, cancel first
        if (dragElement) {
          cancelDrag();
        }
        
        currentFoodId = foodId;
        
      // Show plate on first click
      if (!plateShown) {
        showPlate();
      }
        
        // Create drag element from plate version (EXACTLY like Chapter 1)
        const dragData = createDragFoodItem(foodId);
        if (!dragData || !dragData.element) {
          return;
        }
        
        dragElement = dragData.element;
        dragElementBbox = dragData.bbox;
        
        // Position at cursor (EXACTLY like Chapter 1)
        const svgPoint = screenToSVG(coords.clientX, coords.clientY);
        const centerX = svgPoint.x - (dragElementBbox.width / 2);
        const centerY = svgPoint.y - (dragElementBbox.height / 2);
        
        // Position drag element using SVG.js (EXACTLY like Chapter 1)
        dragElement.transform({ x: 0, y: 0, scale: 1 });
        dragElement.move(centerX, centerY);
        dragElement.scale(1);
        dragElement.opacity(1);
        dragElement.show();
        
        svgContainer.style.cursor = 'none';
        
        // Remove any existing listeners (EXACTLY like Chapter 1)
        svgContainer.removeEventListener('mousemove', handleMouseMove);
        svgContainer.removeEventListener('touchmove', handleMouseMove);
        if (currentClickHandler) {
          svgContainer.removeEventListener('click', currentClickHandler, true);
          svgContainer.removeEventListener('click', currentClickHandler, false);
          svgContainer.removeEventListener('touchend', currentClickHandler, true);
          svgContainer.removeEventListener('touchend', currentClickHandler, false);
          currentClickHandler = null;
        }
        svgContainer.removeEventListener('click', handleClick);
        svgContainer.removeEventListener('click', handleClick, true);
        svgContainer.removeEventListener('touchend', handleClick);
        svgContainer.removeEventListener('touchend', handleClick, true);
        
        // Add event listeners - mouse and touch (EXACTLY like Chapter 1)
        svgContainer.addEventListener('mousemove', handleMouseMove);
        svgContainer.addEventListener('touchmove', handleMouseMove, { passive: false });
        
        // Create a one-time click/touch handler wrapper (EXACTLY like Chapter 1)
        const oneTimeClickHandler = function(e) {
          svgContainer.removeEventListener('click', oneTimeClickHandler, true);
          svgContainer.removeEventListener('touchend', oneTimeClickHandler, true);
          currentClickHandler = null;
          handleClick(e);
        };
        
        currentClickHandler = oneTimeClickHandler;
        svgContainer.addEventListener('click', oneTimeClickHandler, true);
        svgContainer.addEventListener('touchend', oneTimeClickHandler, true);
        
        // Immediately update position
        handleMouseMove(e);
      };
      
      // Add both click and touch listeners to food element
      foodElement.addEventListener('click', foodClickHandler);
      foodElement.addEventListener('touchstart', foodClickHandler, { passive: false });
    });
    
    // Make feast message clickable to trigger food grab and audio (hotspot is hidden)
    const feastMessage = svg.querySelector('#feast-message');
    
    // Function to trigger a food item grab (prefer pasteles if available)
    const triggerFoodGrab = function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Start audio first (if available)
      if (window.McmnExperience && window.McmnExperience.chapter3AudioStart && window.McmnExperience.chapter3AudioStart[sectionType]) {
        window.McmnExperience.chapter3AudioStart[sectionType]();
      }
      
      // Prefer pasteles, but fall back to any available food item
      let foodIdToGrab = 'pasteles';
      const pastelesElement = svg.querySelector('#pasteles');
      
      if (!pastelesElement || pastelesElement.classList.contains('disabled')) {
        // Pasteles not available, find first available food item
        for (const foodId of Object.keys(foodItems)) {
          const foodElement = svg.querySelector('#' + foodId);
          if (foodElement && !foodElement.classList.contains('disabled')) {
            foodIdToGrab = foodId;
            break;
          }
        }
      }
      
      const foodElement = svg.querySelector('#' + foodIdToGrab);
      if (foodElement && !foodElement.classList.contains('disabled')) {
        // Simulate a click on the food element
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          clientX: e.clientX || window.innerWidth / 2,
          clientY: e.clientY || window.innerHeight / 2
        });
        foodElement.dispatchEvent(clickEvent);
      }
    };
    
    if (feastMessage) {
      feastMessage.style.cursor = 'pointer';
      feastMessage.style.pointerEvents = 'auto';
      feastMessage.addEventListener('click', triggerFoodGrab);
      feastMessage.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerFoodGrab(e);
      }, { passive: false });
    }

    // Register cleanup handler for when chapter is offloaded
    if (Mcmn.registerChapterInstance) {
      Mcmn.registerChapterInstance(sectionType, {
        cleanup: function() {
          // Stop audio for this chapter
          if (Mcmn.stopAudioForSection) {
            Mcmn.stopAudioForSection(sectionType);
          }

          // Kill all GSAP animations
          if (plateElement) gsap.killTweensOf(plateElement);
          if (svg) gsap.killTweensOf(svg);
          if (svgContainer) gsap.killTweensOf(svgContainer);

          // Clean up all SVG content - remove children to free memory
          while (svg && svg.firstChild) {
            svg.removeChild(svg.firstChild);
          }

          // Mark SVG as unloaded AND remove it from container so it reloads on next visit
          if (svgContainer) {
            svgContainer.setAttribute('data-svg-loaded', 'false');
            svgContainer.style.cursor = '';
            // Also remove the SVG element itself so it gets reloaded fresh
            const svgElement = svgContainer.querySelector('svg');
            if (svgElement && svgElement.parentNode) {
              svgElement.parentNode.removeChild(svgElement);
            }
          }
        }
      });
    }
  }

  // Export functions to shared namespace
  Mcmn.initChapter3 = initChapter3;

})(Drupal, once);